import {getBaseURL, getPostRequestOptions} from '../utils';

export const basicPOST = async <R>(path: string, params: unknown): Promise<R> =>
    fetch(`${getBaseURL()}/llm-services/${path}`, getPostRequestOptions(params))
        .then(res => {
            return res.json();
        })
        .then(data => data);
